import { getDefaultErrorStringForXhr } from 'zoomforth_tools/error_messaging.js';

(function() {

  zfrespond.models.ExposedField = Backbone.Model.extend({
    initialize: function() {
      this.listenTo(this, 'error', function(model, xhr, opts) {
        alert(getDefaultErrorStringForXhr(xhr));
      });
    }

  });
  

  zfrespond.models.ExposedFields = Backbone.Collection.extend(_.extend({}, {

    initialize: function(models, options) {
      this.mediaCollector = options.mediaCollector;
    },
  
    getFieldIndex: function(fieldId) {
      return this.mediaCollector.get('field_order').indexOf(fieldId);
    },
  
    comparator: function(model) {
      return this.getFieldIndex(model.id);
    }

  }));


}());